<div class="modal-header">
    <h3>Thêm loại quyền lợi {{benefitCode ? 'chi tiết' : ''}}</h3>
</div>
<div class="modal-body">
    <div class="example-form d-flex flex-column" [formGroup]="editForm">
        <div class="row">
            <div class="cms-container col-lg-12">
                <nz-form-label>Loại quyền lợi <span class="red">(*)</span></nz-form-label>
                <div class="cms-container">
                    <dropdown [value]="editForm.value.benefitCode" [list]="benefitTypes" [key]="'code'"
                        (result)="patchValue('benefitCode', $event.code)" [title]="'Chọn loại quyền lợi'" [disabled]="benefitCode">
                    </dropdown>
                </div>
                <app-error-text [isDisplay]="isSaved && editForm.get('benefitCode')?.errors?.required"
                    [message]="'Loại quyền lợi bắt buộc nhập.'">
                </app-error-text>
            </div>
            <div class="cms-container col-lg-12 mt-4" *ngIf="isHasBenefitDetail">
                <nz-form-label>Loại quyền lợi chi tiết</nz-form-label>
                <div class="cms-container">
                    <dropdown [value]="editForm.value.benefitDetailCode" [list]="benefitDetails" [key]="'code'" [disabled]="!editForm.value.benefitCode"
                        (result)="patchValue('benefitDetailCode', $event.code)" [title]="'Chọn loại quyền lợi chi tiết'">
                    </dropdown>
                </div>
                <app-error-text [isDisplay]="isSaved && editForm.get('benefitDetailCode')?.errors?.required"
                    [message]="'Loại quyền lợi chi tiết bắt buộc nhập.'">
                </app-error-text>
            </div>
        </div>
        <div class="group-btn">
            <button class="btn common__btn" (click)="save()">Thêm</button>
            <button class="btn btn__cancel" (click)="cancel()">Hủy bỏ</button>
        </div>
    </div>
</div>